import { useHistory } from 'react-router-dom';
import { useCurrentArtistIdOrNull } from '../../../artists';
import type { FundraisingLocationState } from '../types';

export function useGoToCurrentArtistProfile() {
  const history = useHistory<FundraisingLocationState>();
  const currentArtistId = useCurrentArtistIdOrNull();

  return function goHome() {
    if (!currentArtistId) {
      // This shouldn't happen
      history.push('/');
    } else {
      history.push(`/artist/${currentArtistId}/profile/overview`);
    }
  };
}
